import React from "react";

const AdminPage = () => {
    return (
        <>
            admin nih ges
        </>
    )
}

export default AdminPage;